<script>
export default {
  name: 'ReportNode',
  props: {report: Object}
};
</script>

<template>
<div>
  <router-link
    class="title-box clickable"
    :to="`/reports/${report.tableauMenuConfigId}`"
  >
    <b-icon-file-earmark-bar-graph />
    {{ report.title }}
  </router-link>
</div>
</template>

<style scoped>
.icon-button {
  visibility: hidden;
  display: inline-block;
  cursor: pointer;
  float: right;
  vertical-align: bottom;
  z-index: 10;
}

.title-box {
  display: inline-block;
  width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title-box:visited {
  color: inherit !important;
}

.title-box:focus {
  color: inherit !important;
}

.title-box:hover {
  color: inherit !important;
  text-decoration: none !important;
}
</style>